import { IGridCanInfo } from "common/model";
import { IContactGridDataHttp, IContactInfoHttp } from "../contacts/contact-grid.model";

export interface IFamilyGridRowHttp {
    familyGuid: string;
    reference: number;
    canInfo: IGridCanInfo;
    familyGridDatas: IContactGridDataHttp[];
}

export interface IFamilyGridInfoHttp {
    projectId: number;
    formGuid: string;
    familyTitle: string;
    familyDescription: string;
    familyInfos: ReadonlyArray<IContactInfoHttp>;
    familyGridRows: ReadonlyArray<IFamilyGridRowHttp>;
}

export interface IGetFamilyHeaderByProjectId {
    projectId: number;
    familyGuid: string;
    familyTitle: string;
    familyDescription: string;
    isActive: boolean;
    // Member contact guids (added for the family filters). Optional so an older API
    // response degrades to the per-family member fetch.
    familyContacts?: string[];
    // Per-project sequential family reference (0 = created before references existed).
    reference?: number;
    formattedAddress?: string;
    // Computed client-side for the family filters (see familyDisplayLabel).
    displayLabel?: string;
}

// Families can share a surname ("Kerr" twice in one project) — the per-project reference
// number distinguishes them in dropdown labels; the address renders as a secondary line
// in the option template where available.
export const familyDisplayLabel = (f: IGetFamilyHeaderByProjectId): string =>
    f.reference && f.reference > 0 ? `${f.familyTitle} #${f.reference}` : f.familyTitle;